import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Breadcrumb from '../../../components/Dashboard/Breadcrumbs/Breadcrumb.tsx';
import FloatingShape from '../../../components/FloatingShape/FloatingShape.jsx';
import { ArrowLeft } from 'lucide-react';
import { Flip, ToastContainer, toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { motion } from "framer-motion";
import axios from '../../../api/axios.js';
import { userContext } from '../../../context/UserRoleContext.jsx';
import ErrorMessage from '../../../components/ErrorMessage/ErrorMessage.jsx';
import FullScreenAnimation from '../../../components/fullScreenAnimation/FullScreenAnimation.jsx';

// import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';
// import LogoDark from '../../images/logo/logo-dark.svg';
// import Logo from '../../images/logo/logo.svg';

const SignUp: React.FC = () => {
  const { setAuthenticated } = useContext(userContext);
  const [showAnimation, setShowAnimation] = useState(false);



  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathName || "/";
  const [messages,setMessages] = useState({userEmail:null,userPubgId:null,username:null});

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  useEffect(() => {
    // console.log(authenticated, "Updated authenticated value");
  }, []);
  return (
    <>
    {showAnimation ? (
        <FullScreenAnimation onAnimationEnd={() => setShowAnimation(false)} />
      ) :(<>
      <div className="min-h-screen  flex items-center justify-center relative overflow-hidden">
      <FloatingShape
        color="bg-green-500"
        size="w-64 h-64"
        top="-5%"
        left="10%"
        delay={0}
      />
      <FloatingShape
        color="bg-emerald-500"
        size="w-48 h-48"
        top="70%"
        left="80%"
        delay={5}
      />
      <FloatingShape
        color="bg-lime-500"
        size="w-32 h-32"
        top="40%"
        left="-10%"
        delay={2}
      />
      {/* <div className="w-full max-w-md">{children}</div> */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-md w-full p-2 m-2 bg-gray-800 bg-opacity-50 backdrop-filter backdrop-blur-xl rounded-2xl shadow-xl overflow-hidden"
      >
        <div className="p-8">
          {/* <div className="px-8 py-4 bg-gray-900 bg-opacity-50 flex justify-start">
            <Link
              to={"/"}
              className="text-sm text-green-400 hover:underline flex items-center"
            >
              <ArrowLeft className="h-4 w-4 mr-2" /> Back to Home
            </Link>
          </div> */}
          <div className="flex justify-center items-center">
            {/* <img src={logo} className="w-mx-auto" style={{ height: "150px" }} /> */}
          </div>
          <div className=" flex flex-col items-center">
            <div className="">
              {/* <div className="flex flex-col items-center">
                <button className="w-full mt-3 max-w-xs font-bold shadow-sm rounded-lg py-3 bg-green-100 text-gray-800 flex items-center justify-center transition-all duration-300 ease-in-out focus:outline-none hover:shadow focus:shadow-sm focus:shadow-outline">
                  <div className="bg-white p-2  rounded-full">
                    <svg className="w-4" viewBox="0 0 533.5 544.3">
                      <path
                        d="M533.5 278.4c0-18.5-1.5-37.1-4.7-55.3H272.1v104.8h147c-6.1 33.8-25.7 63.7-54.4 82.7v68h87.7c51.5-47.4 81.1-117.4 81.1-200.2z"
                        fill="#4285f4"
                      />
                      <path
                        d="M272.1 544.3c73.4 0 135.3-24.1 180.4-65.7l-87.7-68c-24.4 16.6-55.9 26-92.6 26-71 0-131.2-47.9-152.8-112.3H28.9v70.1c46.2 91.9 140.3 149.9 243.2 149.9z"
                        fill="#34a853"
                      />
                      <path
                        d="M119.3 324.3c-11.4-33.8-11.4-70.4 0-104.2V150H28.9c-38.6 76.9-38.6 167.5 0 244.4l90.4-70.1z"
                        fill="#fbbc04"
                      />
                      <path
                        d="M272.1 107.7c38.8-.6 76.3 14 104.4 40.8l77.7-77.7C405 24.6 339.7-.8 272.1 0 169.2 0 75.1 58 28.9 150l90.4 70.1c21.5-64.5 81.8-112.4 152.8-112.4z"
                        fill="#ea4335"
                      />
                    </svg>
                  </div>
                  <span className="ml-4">Sign In with Google</span>
                </button>
              </div> */}

              <div className="my-2  text-center">
                <small className='text-sm font-bold'>Note :</small><small> This is very sensitive information as it will be used for giving out prizes.</small>
                <div className="leading-none text-xl  px-2 mb-2 inline-block text-sm text-gray-600 tracking-wide font-medium text-white transform translate-y-1/2">
                 Player Registration.
                </div>
              </div>
              <ToastContainer />

              <div className=" ">
                <form
                  onSubmit={
                    
                    handleSubmit(async (data) => {
                    // setDisabled(true);
                    console.log(data,errors);
                    const formData = {
                      name:data.name,
                      username:data.username,
                      pubgId:data.pubgId,
                      email: data.email,
                      password: data.password,
                      pubgName:data.pubgName
                    };
                    toast.promise(
                      axios
                        .post("auth/signup", formData, {
                          withCredentials: true,
                        })
                        .then(async function (response) {
                          // console.log(response);
                          toast.success("Signup successfull! 👌", {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                            transition: Flip,
                          });
                          const newresponse = await response?.data;
                          const accessToken = await response?.data.accessToken;
                          const roles = await response?.data.user.role;
                          // localStorage.setItem("token", newresponse.token);
                          // console.log(roles, accessToken, newresponse.user);
                          setAuthenticated({
                            user: newresponse.user,
                            roles: [roles],
                            accessToken,
                          });
                          // console.log(authenticated);
                          // // setRole(roles);
                          // localStorage.setItem("login", true);
                          setShowAnimation(true);


                          setTimeout(() => {
                            navigate("/verifyEmail", { replace: true });
                          }, 3000);
                          // navigate("/verifyEmail");

                          // setDisabled(false);
                          // document.getElementById("quote-form").reset();
                        })
                        .catch(async function (error) {
                          console.log(error,error?.response?.data?.message);
                          setMessages(error?.response?.data)
                        
                            toast.error(`Something went wrong...`, {
                              position: "top-right",
                              autoClose: 5000,
                              hideProgressBar: false,
                              closeOnClick: true,
                              pauseOnHover: true,
                              draggable: true,
                              progress: undefined,
                              theme: "colored",
                              transition: Flip,
                            });
                          
                          // setDisabled(false);
                        }),
                      {
                        pending: "Please wait! we are signing you up!",
                        // success: "Promise resolved 👌",
                        // error: "Promise rejected 🤯",
                      }
                    );
                  })}
                >
                    <input
                    {...register("name", {
                      required: "This field is required.",
                    })}
                    className="w-full text-black my-2 px-6 py-2 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white"
                    type="text"
                    placeholder="Enter CNIC exact Fullname"
                  />
                      <ErrorMessage error={errors?.name} />
                          <input
                    {...register("username", {
                      required: "This field is required.",
                    })}
                    className="w-full text-black my-2 px-6 py-2 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white"
                    type="text"
                    placeholder="Username"
                  />
                      <ErrorMessage error={errors?.username} />
                      <small className={` ${messages?.username !==null ? "text-red-500": ""} text-sm `}>

                      {messages?.username ? messages.username : ""}
                      </small>

                      

                   {/* {errors?.username && <p>{errors?.username.message as String}</p>} */}
                  <input
                    {...register("email", {
                      required: "This field is required.",
                    })}
                    className="w-full my-2 text-black px-6 py-2 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white"
                    type="email"
                    placeholder="Email"
                  />
                      <ErrorMessage error={errors?.email} />
                      <small className={` ${messages?.userEmail !==null ? "text-red-500": ""} text-sm `}>
                      {messages?.userEmail ? messages.userEmail : ""}
                      </small>
                    

                   {/* {errors?.email && <p>{errors?.email.message as String}</p>} */}
                            <input
                    {...register("pubgName", {
                      required: "This field is required.",
                      maxLength: {
                        value: 10,
                        message: "Maximum 14 characters allowed",
                      },
                    })}
                    className="w-full my-2 text-black text-black px-6 py-2 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white"
                    type="text"
                    placeholder="In-Game PUBG Name (copy & paste from game**)"
                  />
                      <ErrorMessage error={errors?.pubbgName} />

                     {/* {errors?.pubbgName && <p>{errors?.pubbgName.message as String}</p>} */}
                       <input
                    {...register("pubgId", {
                      required: "This field is required.",
                    })}
                    className="w-full my-2 text-black text-black px-6 py-2 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white"
                    type="text"
                    placeholder="PUBG ID"
                  />
                      <ErrorMessage error={errors?.pubgId} />
                     <small className={` ${messages?.userPubgId !==null ? "text-red-500": ""} text-sm `}>
                      {messages?.userPubgId ? messages.userPubgId : ""}
                      </small> 


                     {/* {errors?.pubgId && <p>{errors?.pubgId.message as String}</p>} */}
                  
                  <input
                    {...register("password", {
                      required: "This field is required.",
                    })}
                    className="w-full my-2 text-black px-6 py-2 rounded-lg font-medium bg-gray-100 border border-gray-200 placeholder-gray-500 text-sm focus:outline-none focus:border-gray-400 focus:bg-white mt-5"
                    type="password"
                    placeholder="Password"
                  />
                      <ErrorMessage error={errors?.password} />

                     {/* {errors?.password && <p>{errors?.password.message as String}</p>} */}

                  <button
                    type="submit"
                    // onClick={login}
                    className="mt-5 tracking-wide font-semibold bg-purple-700 text-white w-full py-4 rounded-lg hover:bg-purple-900 hover:text-white transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none"
                  >
                
                    <span className="ml-">Sign Up</span>
                  </button>
                </form>
                <p className="mt-6 text-white text-xs text-gray-600 text-center">
                  I agree to abide by PlayerzPortal
                  <a
                    href="#"
                    className="border-b text-xs mx-2 border-gray-500 border-dotted"
                  >
                    Terms of Service
                  </a>
                  and its
                  <a
                    href="#"
                    className="border-b mx-2 text-xs border-gray-500 border-dotted"
                  >
                    Privacy Policy
                  </a>
                </p>
              
                <p className="mt-6 text-white text-xs text-gray-600 text-center">
                  Already have an account?
                  <Link
                    to={"/login"}
                    className="border-b mx-2 border-gray-500 border-dotted"
                  >
                   Login now!
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="flex-1 bg-green-100 text-center hidden lg:flex">
          <div
            className="m-12 xl:m-16 w-full bg-contain bg-center bg-no-repeat"
            style={{ backgroundImage: `url(${loginImage})` }}
          ></div>
        </div> */}
      </motion.div>
    </div>
      
      </>)}
      

    </>
  );
};

export default SignUp;
